import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './PolicyPage.css';

function PolicyPage({ title, filePath }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = `${title} | Handmade Haven`;
  }, [title]);
  
  useEffect(() => {
    let isMounted = true;

    const loadContent = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}${filePath}`);
        if (!response.ok) {
          throw new Error('Unable to load content. Please try again later.');
        }
        const text = await response.json ? await response.text() : '';
        if (isMounted) {
          setContent(text);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || 'Something went wrong while loading content.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadContent();

    return () => {
      isMounted = false;
    };
  }, [filePath]);

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1 className="policy-title">{title}</h1>

        {loading && <div className="policy-status">Loading content…</div>}
        {error && !loading && (
          <div className="policy-status policy-status-error">
            {error}
          </div>
        )}

        {!loading && !error && (
          <div className="policy-content">
            <ReactMarkdown
              components={{
                h1: ({ node, ...props }) => <h2 {...props} />,
                h2: ({ node, ...props }) => <h3 {...props} />,
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}

export default PolicyPage;


